import React from "react";

import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkBreaks from "remark-breaks";

/**
 * Renders a markdown string with the grayteck palette in both themes.
 *
 * remarkBreaks turns a single newline into a line break. Standard markdown
 * collapses those into one paragraph, which would leave every engagement
 * written before this component landed looking exactly as unreadable as it
 * did before. With it, legacy plain text keeps its shape and new markdown
 * still renders as markdown.
 *
 * Raw HTML in the source is escaped, not rendered. react-markdown does that
 * by default as long as rehype-raw is not added, so untrusted engagement
 * text cannot inject markup.
 */
const MarkdownText = ({ children, className = "" }) => {
  if (!children || typeof children !== "string" || !children.trim()) {
    return null;
  }

  return (
    <div
      className={`prose prose-sm max-w-none
                  text-grayteck-900 dark:text-grayteck-100
                  prose-headings:text-grayteck-900 dark:prose-headings:text-grayteck-100
                  prose-headings:font-display prose-headings:font-semibold
                  prose-h1:text-base prose-h2:text-base prose-h3:text-sm
                  prose-p:text-grayteck-900 dark:prose-p:text-grayteck-100
                  prose-strong:text-grayteck-900 dark:prose-strong:text-grayteck-50
                  prose-li:text-grayteck-900 dark:prose-li:text-grayteck-100
                  prose-li:my-0.5 prose-ul:my-2 prose-ol:my-2
                  prose-a:text-gold-600 dark:prose-a:text-gold-400
                  prose-code:text-grayteck-800 dark:prose-code:text-grayteck-200
                  prose-code:bg-grayteck-100 dark:prose-code:bg-darkbg-700
                  prose-code:px-1 prose-code:py-0.5 prose-code:rounded
                  prose-code:before:content-none prose-code:after:content-none
                  prose-blockquote:text-grayteck-700 dark:prose-blockquote:text-grayteck-300
                  prose-blockquote:border-l-grayteck-300 dark:prose-blockquote:border-l-grayteck-600
                  prose-hr:border-grayteck-200 dark:prose-hr:border-darkbg-600
                  prose-table:text-grayteck-900 dark:prose-table:text-grayteck-100
                  prose-th:text-grayteck-900 dark:prose-th:text-grayteck-100
                  ${className}`}
    >
      <ReactMarkdown remarkPlugins={[remarkGfm, remarkBreaks]}>
        {children}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownText;
